import { render, staticRenderFns } from "./DetailsSectionInvoiceItems.vue?vue&type=template&id=2e18ee24&scoped=true&"
import script from "./DetailsSectionInvoiceItems.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionInvoiceItems.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSectionInvoiceItems.vue?vue&type=style&index=0&id=2e18ee24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18ee24",
  null
  
)

export default component.exports